module.exports = "<ins class=\"27ff66ea\" data-key=\"244d6653984e6d0b384d88046557323b\"></ins>\r\n"